import { type SellScreenActionTypes } from "../../Actions/SellScreen/SellScreenActions";
import { SALE_TOGGLE_DISPLAY_NOTE } from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

export interface SummaryState {
    notesVisible: boolean;
}

function SellScreenActionSummaryReducer(
    state: SummaryState | undefined,
    action: ShopfrontActions<SellScreenActionTypes>
): SummaryState {
    if(typeof state === "undefined") {
        return {
            notesVisible: false,
        };
    }

    switch(action.type) {
        case SALE_TOGGLE_DISPLAY_NOTE:
            return {
                notesVisible: !state.notesVisible,
            };
        default:
            return state;
    }
}

export default SellScreenActionSummaryReducer;
